import { showErrorMessage } from 'actions/messages';
import { qualificationsApi } from 'services/api/qualifications-api';
import {
  WORK_ORDERS_DETAILS_QUALIFICATIONS_ADD_SUCCESS,
  WORK_ORDERS_DETAILS_QUALIFICATIONS_LOAD_SUCCESS,
  WORK_ORDERS_DETAILS_QUALIFICATIONS_MODAL_SHOW,
  WORK_ORDERS_DETAILS_QUALIFICATIONS_OPTION_SELECTED,
  WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED,
  WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_BY_ID_SET,
  WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_CLEAR,
  WORK_ORDERS_DETAILS_QUALIFICATIONS_TRADES_LOAD_SUCCESS,
} from 'actions/admin/work-orders/action-types';
import { tradesApi } from 'services/api/trades-api';

export function addQualificationRequest(values) {
  return (dispatch) => {
    return qualificationsApi.createQualification(values).then((response) => {
      if (response.ok) {
        dispatch(setShowNewQualificationModal(false));
        dispatch(addQualificationSuccess(response.qualification));
        // Mark added qualification as selected
        dispatch(qualificationSelected(response.qualification.id));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function addQualificationSuccess(qualification) {
  return {
    type: WORK_ORDERS_DETAILS_QUALIFICATIONS_ADD_SUCCESS,
    payload: qualification,
  };
}

export function clearQualificationsSelected() {
  return {
    type: WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_CLEAR,
  };
}

export function loadDefaultQualificationsRequest() {
  return (dispatch) => {
    return qualificationsApi.getQualifications(true).then((response) => {
      if (response.ok) {
        dispatch(loadQualificationsSuccess(response.qualifications));
        // Select all default qualifications
        response.qualifications.forEach((qualification) =>
          dispatch(qualificationSelected(qualification.id))
        );
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadQualificationsSuccess(qualifications) {
  return {
    type: WORK_ORDERS_DETAILS_QUALIFICATIONS_LOAD_SUCCESS,
    payload: qualifications,
  };
}

export function loadTradesRequest() {
  return (dispatch) => {
    return tradesApi.getTrades().then((response) => {
      if (response.ok) {
        dispatch(loadTradesSuccess(response.trades));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadTradesSuccess(trades) {
  return {
    type: WORK_ORDERS_DETAILS_QUALIFICATIONS_TRADES_LOAD_SUCCESS,
    payload: trades,
  };
}

export function optionSelected(qualificationId, option) {
  return {
    type: WORK_ORDERS_DETAILS_QUALIFICATIONS_OPTION_SELECTED,
    payload: { qualificationId, option },
  };
}

export function qualificationSelected(qualificationId) {
  return {
    type: WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED,
    payload: qualificationId,
  };
}

export function setSelectedQualificationsById(selectedQualificationsById) {
  return {
    type: WORK_ORDERS_DETAILS_QUALIFICATIONS_SELECTED_BY_ID_SET,
    payload: selectedQualificationsById,
  };
}

export function setShowNewQualificationModal(show) {
  return {
    type: WORK_ORDERS_DETAILS_QUALIFICATIONS_MODAL_SHOW,
    payload: show,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/qualifications.js